import React from "react";

const Incident = () => {
  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.title}>🚧 Under Maintenance</h1>
        <p style={styles.text}>
          The Incident page is currently unavailable.
          We are working on it. Please check back soon.
        </p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#0f172a",
  },
  card: {
    padding: "40px",
    borderRadius: "12px",
    backgroundColor: "#1e293b",
    boxShadow: "0 4px 15px rgba(0,0,0,0.6)",
    textAlign: "center",
  },
  title: {
    marginBottom: "15px",
    color: "#f87171", // soft red
  },
  text: {
    color: "#cbd5e1",
  },
};

export default Incident;